<template>
  <!--
          作者：tao
          时间：2020-12-11
          描述：抽奖码-奖品列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">

      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">

        <el-form-item label="抽奖码名称"><el-input size="small" v-model="formInline.code" placeholder="请输入抽奖码名称"></el-input></el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>


    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="lottery_id" label="ID" width="80"></el-table-column>

          <el-table-column prop="code" label="抽奖码"></el-table-column>
          <el-table-column prop="is_export" label="是否导出" width="80">
            <template slot-scope="scope">

              <span v-if="scope.row.is_export == 0">未导出</span>
              <span v-if="scope.row.is_export == 1" class="green">已导出</span>
            </template>
          </el-table-column>
          <el-table-column prop="export_time" label="导出时间" width="140">

          </el-table-column>
          <el-table-column prop="create_time" label="添加时间" width="140"></el-table-column>

        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <el-button size="small" type="info" @click="cancelFunc">返回</el-button>

  </div>
</template>

<script>
import LotteryApi from '@/api/lottery.js';

export default {
  components: {
    /*编辑组件*/

  },
  data() {
    return {
      batch:0,
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {

        code:""
      },

      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      /*等级*/
      gradeList: []
    };
  },
  created() {
    /*获取列表*/
    this.batch = this.$route.query.batch;
    this.getTableList();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.batch = self.batch;
      LotteryApi.getLotteryData(Params, true)
        .then(data => {
          console.log(data)
          self.loading = false;
          self.tableData = data.data.detail.data;
          self.totalDataNumber = data.data.detail.total;

        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let Params = self.formInline;
      self.getTableList();
    },

    /*打开添加*/
    addClick() {

      this.$router.push('/plus/lottery/prize/add');
    },

    /*取消*/
    cancelFunc() {
      /*存储缓存*/
      localStorage.setItem('activeName','lottery')
      this.$router.push({
        path: '/plus/lottery/index',
        query: {
          active: 'lottery',

        }
      });

    },

    /*打开编辑*/
    editClick(row) {
      this.$router.push({
        path: '/plus/lottery/prize/edit',
        query: {
          lottery_prize_id: row.lottery_prize_id,
          scene: 'edit'
        }
      });
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    },

    /*删除用户*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          LotteryApi.deletePrice(
            {
              lottery_prize_id: row.lottery_prize_id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，删除成功',
                  type: 'success'
                });
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    }
  }
};
</script>
<style>
  .pic{width: 80;height: 80;}
</style>



// WEBPACK FOOTER //
// src/views/plus/lottery/lottery/detail.vue